import React from 'react';
import { ArrowDown } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  const goToGallery = () => {
    navigate('/gallery');
  };

  const goToContact = () => {
    navigate('/contact');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-black overflow-hidden grain-texture">
      {/* Background Image with Overlay - More Subtle and Elegant */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1519167758481-83f29da8c2b6?w=1920)',
          opacity: 0.25
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 text-center px-6 py-20 max-w-5xl mx-auto">
        <div className="fade-in-up">
          <h1 className="heading-font text-6xl md:text-7xl font-bold text-white mb-8 tracking-wide leading-tight">
            Elysian Evenings
          </h1>
          <div className="w-24 h-1 gold-bg mx-auto mb-8"></div>
          <p className="heading-font text-xl md:text-2xl gold-accent font-light mb-8 leading-relaxed">
            Designing unforgettable large-scale premium entertainment experiences for conferences, award nights, and elite gatherings
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-12">
            <Button 
              onClick={goToGallery}
              className="gold-bg text-black hover:bg-yellow-600 px-8 py-5 text-base font-semibold body-font rounded-sm shadow-2xl"
            >
              View Experience Portfolio
            </Button>
            <Button 
              onClick={goToContact}
              className="bg-transparent border-2 border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-black px-8 py-5 text-base font-semibold body-font rounded-sm transition-all"
            >
              Schedule a Consultation
            </Button>
          </div>
          <p className="body-font text-sm text-gray-400 mt-8 italic">
            "Crafted with precision. Delivered with impact."
          </p>
        </div>
        
        {/* Scroll Indicator */}
        <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ArrowDown className="text-white opacity-50" size={32} />
        </div>
      </div>
    </section>
  );
};

export default Hero;
